import {ArrayUtils} from "../../utils/arrayUtils";
import { KpiFilterState, SelectableItem} from "../../types/types";

export type ApiFilters = {
    designations: string[],
    activeStatus: string[],
    users: string[]
}

export class ApiFilterConverter {
    //filter=designation[in]:[retailer] and activeStatus:active and loginId[in]:[3007/M65,700-P1418]

    public parse(filter: string): ApiFilters {
        const filters: ApiFilters = {
            designations: [],
            activeStatus: [],
            users: []
        }
        try {
            if (filter) {
                const splitedItems = filter.replace("filter=", "").split(" and ").map(i => i.trim());
                for (let item of splitedItems) {
                    if (item.startsWith("activeStatus")) {
                        filters.activeStatus.push(item.replaceAll("activeStatus:", ""));
                    } else {
                        const pair = item.split("[in]:")
                        const key = pair[0] as 'designation' | 'loginId'
                        const matches = pair[1].match(/\[(.*?)]/);
                        const value = matches ? matches[1].split(",") : []
                        if (key === 'designation') {
                            filters.designations = value;
                        }
                        if (key === "loginId") {
                            filters.users = value;
                        }
                    }
                }
            }
        } catch (er) {
            console.log(er)
        }
        return filters;
    }

    getSelectedItems<T>(items: SelectableItem<T>[]): T[] {
        return items.filter(i => i.isSelected).map(i => i.item)
    }

    generateTargetFilter(filter: KpiFilterState) {
        const newFilters = []
        const designations = this.getSelectedItems(filter.designations);
        if (ArrayUtils.isNotEmpty(designations)) {
            newFilters.push("designation[in]:[" + designations.map(i => i.divisionName).join(",") + "]");
        }
        const activeStatus = this.getSelectedItems(filter.activeStatus);
        // if active status is more than one then we need to check both active and inactive so we can ignore this filter
        if (activeStatus && activeStatus.length === 1) {
            newFilters.push("activeStatus:" + activeStatus[0])
        }
        const users = this.getSelectedItems(filter.users);
        if (ArrayUtils.isNotEmpty(users)) {
            newFilters.push("loginId[in]:[" + users.join(",") + "]");
        }
        return ArrayUtils.isNotEmpty(newFilters) ? "filter=" + newFilters.join(" and ") : "";
    }
}